import { render } from "./S218090.vue?vue&type=template&id=45670b81"
const script = {}
script.render = render

export default script